import { useAdminLanguage } from '../../AdminLanguageContext';
import { translateAdmin } from '../../utils/adminTranslations';

const AdminText = ({ children }) => {
  const { language } = useAdminLanguage();
  const text = typeof children === 'string' ? children.trim().replace(/\s+/g, ' ') : children;
  return translateAdmin(text, language);
};

export default AdminText;
